import React from 'react';
import {
  Card,
  CardContent,
  Avatar,
  Typography,
  Box,
  Divider,
  Chip
} from '@mui/material';
import {
  Email as EmailIcon,
  Phone as PhoneIcon,
  Badge as DocumentIcon,
  Work as JobIcon
} from '@mui/icons-material';

const MemberCard = ({ cliente, sx = {} }) => {
  // Si no hay cliente seleccionado, no mostrar nada
  if (!cliente) return null;

  // Función para obtener la primera letra del nombre
  const getInitials = (name) => {
    if (!name) return '?';
    return name.charAt(0).toUpperCase();
  };

  // Función para limpiar el nombre (remover ';' si existe)
  const cleanName = (name) => {
    if (!name) return 'No especificado';
    return name.replace(/;/g, '').trim();
  };

  // Función para mostrar valor o mensaje por defecto
  const displayValue = (value, defaultMessage = 'No especificado') => {
    return value && value.trim() !== '' ? value : defaultMessage;
  };

  // Generar color de avatar basado en el nombre
  const getAvatarColor = (name) => {
    if (!name) return '#9e9e9e';
    const colors = [
      '#f44336', '#e91e63', '#9c27b0', '#673ab7',
      '#3f51b5', '#2196f3', '#03a9f4', '#00bcd4',
      '#009688', '#4caf50', '#8bc34a', '#cddc39',
      '#ffeb3b', '#ffc107', '#ff9800', '#ff5722'
    ];
    const index = name.charCodeAt(0) % colors.length;
    return colors[index];
  };

  // Determinar el tipo de persona y configuración del chip
  const getPersonType = () => {
    if (cliente.role === 'client') {
      return { label: 'Cliente', color: 'primary' };
    } else if (cliente.role === 'partner') {
      return { label: 'Socio', color: 'secondary' };
    } else {
      return { label: 'Persona', color: 'default' };
    }
  };

  const personType = getPersonType();

  return (
    <Card sx={{ maxWidth: 400, ...sx }}>
      <CardContent>
        <Box display="flex" alignItems="center" gap={2} mb={2}>
          <Avatar
            sx={{
              bgcolor: getAvatarColor(cliente.full_name),
              width: 56,
              height: 56,
              fontSize: '1.5rem'
            }}
          >
            {getInitials(cliente.full_name)}
          </Avatar>
          <Box flex={1}>
            <Typography variant="h6" component="h3" noWrap>
              {cleanName(cliente.full_name)}
            </Typography>
            <Chip
              label={personType.label}
              size="small"
              color={personType.color}
              variant="outlined"
            />
          </Box>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box display="flex" flexDirection="column" gap={1.5}>
          <Box display="flex" alignItems="center" gap={1}>
            <EmailIcon color="action" fontSize="small" />
            <Typography variant="body2" color="text.secondary">
              Email:
            </Typography>
            <Typography variant="body2" flex={1}>
              {displayValue(cliente.email)}
            </Typography>
          </Box>

          <Box display="flex" alignItems="center" gap={1}>
            <DocumentIcon color="action" fontSize="small" />
            <Typography variant="body2" color="text.secondary">
              Documento:
            </Typography>
            <Typography variant="body2" flex={1}>
              {displayValue(cliente.document_number)}
            </Typography>
          </Box>

          <Box display="flex" alignItems="center" gap={1}>
            <PhoneIcon color="action" fontSize="small" />
            <Typography variant="body2" color="text.secondary">
              Teléfono:
            </Typography>
            <Typography variant="body2" flex={1}>
              {displayValue(cliente.phone_number)}
            </Typography>
          </Box>

          {/* Mostrar job_position solo si es un partner */}
          {cliente.role === 'partner' && (
            <Box display="flex" alignItems="center" gap={1}>
              <JobIcon color="action" fontSize="small" />
              <Typography variant="body2" color="text.secondary">
                Cargo:
              </Typography>
              <Typography variant="body2" flex={1}>
                {displayValue(cliente.job_position)}
              </Typography>
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default MemberCard;